import { useContext, useState } from "react";
import { connect } from "react-redux";
import { stateType } from "../../store";
import {
  clearCart,
  clearOrderDetails,
  setOrderDetails,
  setOrderInfo,
  setPageCount,
  setPaymentSuccess
} from "../../state_management/actions";
import { setTimeError } from "../../state_management/actions/common";
import { parseIdQuan } from "../../state_management/epics/order";
import { cartItem, extrasCartItem } from "../../state_management/reducers/cart";
import { orderInfo, orderType } from "../../state_management/reducers/order";
import CheckOutConfirm from "./CheckOutConfirm";
import CheckOutPayment from "./CheckOutPayment";
import usePayment from "./usePayment";
import { total } from "./PaymentDirect";
import { split_cart } from "../../utilities/cartUtilities";
import { CouponObjectContext, TotalWithCouponContext } from "../../AppProvider";

export const isDepositAvailable = (data?: number) => {
  const depositUnavailable = isNaN(parseFloat(`${data}`));
  return depositUnavailable;
};

const Payment = ({
  orderDetails,
  cart: c,
  extras,
  orderInfo,
  setOrderDetails,
  setOrderInfo,
  setPageCount,
  clearOrderDetails,
  clearCart,
  setPaymentSuccess,
  setTimeError
}: {
  orderDetails: orderType;
  cart: cartItem[];
  extras: extrasCartItem[];
  orderInfo: orderInfo;
  setOrderDetails: (data: Partial<orderType>) => void;
  setOrderInfo: (data: orderInfo) => void;
  setPageCount: (data: number) => void;
  clearOrderDetails: () => void;
  clearCart: (ignoreAnalytics?: boolean) => void;
  setPaymentSuccess: (data: boolean) => void;
  setTimeError: (data: boolean) => void;
}) => {
  const [totalWithCoupon] = useContext(TotalWithCouponContext);
  const {
    CouponObject: { setError: setCouponError }
  } = useContext(CouponObjectContext);

  const [error, setError] = useState<string>();
  const [processing, setProcessing] = useState(false);
  const [disabled, setDisabled] = useState(true);

  const clientSecret = orderInfo?.clientSecret;

  const { cart, gift_values } = split_cart(c);

  const onlyGift = extras.length + cart.length === 0;
  const usePay = usePayment({
    details: orderDetails,
    setDetails: setOrderDetails,
    gift_values: gift_values.map((gift) => ({
      quantity: gift.quantity,
      service_id: gift.id,
      value: gift.item.price_with_discount
    })),
    extra_services: extras.map((item) => parseIdQuan({ item, extra: true })),
    services: cart.map((item) => parseIdQuan({ item, extra: false })),
    orderInfo,
    setOrderInfo,
    orderErrorCallback: (couponErrorType) => {
      if (couponErrorType) {
        setPageCount(3);
        setCouponError(true, couponErrorType, true);
      } else {
        setPageCount(onlyGift ? 0 : 1);
        setTimeError(true);
      }
      setOrderInfo(null);
    }, //Other
    clientSecret,
    Total: totalWithCoupon,
    setError,
    setDisabled,
    setProcessing,
    setPaymentSuccess,
    startSubmit: () => {},
    successOnSubmit: () => {
      resetOrder();
    },
    cart: c,
    extras: extras
  });

  const TotalDeposit = total(usePay.depositValue, 0);

  const resetOrder = () => {
    /**
     * Clear cart
     * Clear order details
     * Make success true
     * Remove orderinfo
     */
    setPaymentSuccess(true);
    usePay.setPaymentRequired(true);
    setOrderInfo(null);
    clearCart(true);
    setPageCount(0);
    // clearOrderDetails();
  };

  const depositUnavailable = isDepositAvailable(usePay.depositRes.data);

  return orderInfo?.orderId &&
    !orderInfo?.clientSecret &&
    !usePay.paymentRequired ? ( // payment not required
    <CheckOutConfirm
      coupon={orderDetails.coupon_code}
      cart={cart}
      extras={extras}
      Total={totalWithCoupon}
      TotalDeposit={TotalDeposit}
      depositUnavailable={depositUnavailable}
      full_payment={usePay.full_payment}
      paymentTypeHandler={usePay.paymentTypeHandler}
      resetOrder={resetOrder}
      orderId={orderInfo?.orderId}
    />
  ) : (
    <CheckOutPayment
      disabled={disabled}
      error={error}
      processing={processing}
      Total={totalWithCoupon}
      depositUnavailable={depositUnavailable}
      usePay={usePay}
      clientSecret={clientSecret}
      orderId={orderInfo?.orderId}
    />
  );
};

const mapStateToProps = (state: stateType) => ({
  orderDetails: state.orderReducer.details,
  cart: state.cartReducer.cart,
  extras: state.cartReducer.extras,
  orderInfo: state.orderReducer.orderInfo
});

const mapDispatchToProps = (dispatch: any) => ({
  setPageCount: (data: number) => {
    dispatch(setPageCount(data));
  },
  setOrderDetails: (data: Partial<orderType>) => {
    dispatch(setOrderDetails(data) as any);
  },
  setOrderInfo: (data: orderInfo) => {
    dispatch(setOrderInfo(data));
  },
  clearOrderDetails: () => {
    dispatch(clearOrderDetails());
  },
  clearCart: (ignoreAnalytics?: boolean) => {
    dispatch(clearCart(ignoreAnalytics));
  },
  setPaymentSuccess: (data: boolean) => {
    dispatch(setPaymentSuccess(data));
  },
  setTimeError: (data: boolean) => {
    dispatch(setTimeError(data));
  }
});

const ConnectPayment = connect(mapStateToProps, mapDispatchToProps)(Payment);

export default ConnectPayment;
